import { Context } from '@nuxt/types';
import { BaseStore } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { VSF_CURRENCY_COOKIE } from '@vue-storefront/core';

export const checkLang = async (context: Context, config: BaseStore) => {
  const {
    route,
    i18n,
    app: { router },
    localePath
  } = context;
  const lang = i18n.locale;

  const isLangAvailable = config.languages?.some(
    (languages) => languages.isocode === lang
  );

  const defaultLang = config.defaultLanguage?.isocode;

  if (!isLangAvailable && defaultLang) {
    const defaultLangRoute = localePath(route.fullPath, defaultLang);

    await router.push(defaultLangRoute);
  }
};

export const getCurrencyForApi = (context: Context) => {
  const {
    app: { i18n, $cookies }
  } = context;

  const defaultLangCurr = i18n.numberFormats[i18n.locale]?.currency?.currency;
  const cookieCurr = $cookies.get(VSF_CURRENCY_COOKIE);
  return process.client ? cookieCurr ?? defaultLangCurr : defaultLangCurr;
};

export const isCurrencyDifferent = (context: Context) => {
  const {
    app: { i18n, $cookies }
  } = context;

  const defaultLangCurr = i18n.numberFormats[i18n.locale]?.currency?.currency;
  const userSelectedCurr = $cookies.get(VSF_CURRENCY_COOKIE);

  return userSelectedCurr && defaultLangCurr !== userSelectedCurr;
};
